export default "__VITE_ASSET__DRShmoDz__"